// extracted by mini-css-extract-plugin
export default {"container_left":"wc_we","container_right":"wc_wf","container_left_BN":"wc_wg","container_right_BN":"wc_wh","leftDice":"wc_wi","rightDice":"wc_wj","container":"wc_gw"};